// Company type taxonomy used by the Add/Edit Company dialogs. Keeping it in a
// shared module so both forms stay in sync — adding a new type here
// automatically makes it available to both pickers.
export const companyTypes = ['airline', 'third-party', 'internal'];
